module.exports = __webpack_public_path__ + "img/c_photo_6@2x.5073e755.png";